
export const GET_GRADE_BY_ID = 'GET_GRADE_BY_ID';
export const GET_GRADE_BY_ID_SUCCESS = 'GET_GRADE_BY_ID_SUCCESS';
export const GET_STUDENT_BY_ID = ' GET_STUDENT_BY_ID';
export const GET_STUDENT_BY_ID_SUCCESS = 'GET_STUDENT_BY_ID_SUCCESS';
